import styled from 'styled-components';

export const Footer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 0 50px;
  color: var(--color-text-muted);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;

  a {
    color: var(--color-text-muted);
  }
`;
